<template>
  <footer class="playback-bar demo-playback">
    <div class="playback-bar__date"><DemoIcon name="calendar" /><span>10 окт. 2026</span></div>
    <div class="playback-bar__timeline">
      <div class="playback-bar__ticks">
        <span v-for="value in [0, 10, 20, 30]" :key="value">{{ clock(value) }}</span>
      </div>
      <div class="demo-track-wrap">
        <div class="playback-bar__track" aria-hidden="true">
          <div class="playback-bar__recorded" style="left: 0; width: 100%" />
          <div
            class="playback-bar__progress"
            :style="{ left: 0, width: `${(time / 30) * 100}%` }"
          />
          <div class="playback-bar__playhead" :style="{ left: `${(time / 30) * 100}%` }" />
        </div>
        <input
          class="demo-timeline-input"
          type="range"
          min="0"
          max="30"
          step="0.1"
          :value="time"
          aria-label="Время в демоархиве"
          :aria-valuetext="clock(time)"
          @input="$emit('seek', Number(($event.target as HTMLInputElement).value))"
        />
      </div>
    </div>
    <div class="playback-bar__controls">
      <button
        class="playback-bar__control"
        type="button"
        title="Назад 10 с"
        aria-label="Назад на 10 секунд"
        @click="$emit('seek', Math.max(0, time - 10))"
      >
        <DemoIcon name="previous" />
      </button>
      <button
        class="playback-bar__control playback-bar__control--primary"
        type="button"
        :title="playing ? 'Пауза' : 'Продолжить'"
        :aria-label="playing ? 'Приостановить демовидео' : 'Воспроизвести демовидео'"
        @click="$emit('toggle')"
      >
        <DemoIcon :name="playing ? 'pause' : 'play'" />
      </button>
      <button
        class="playback-bar__control"
        type="button"
        title="Вперёд 10 с"
        aria-label="Вперёд на 10 секунд"
        @click="$emit('seek', Math.min(30, time + 10))"
      >
        <DemoIcon name="next" />
      </button>
      <button
        class="playback-bar__speed"
        type="button"
        :aria-label="`Скорость воспроизведения ${speed}×. Изменить`"
        @click="$emit('speed')"
      >
        {{ speed }}×
      </button>
    </div>
  </footer>
</template>
<script setup lang="ts">
defineProps<{ time: number; playing: boolean; speed: number }>();
defineEmits<{ seek: [number]; toggle: []; speed: [] }>();
const clock = (seconds: number) => `14:32:${String(Math.floor(seconds)).padStart(2, '0')}`;
</script>
<style scoped lang="scss">
@use '~/assets/styles/demo/timeline.scss' as *;
.demo-track-wrap {
  position: relative;
  padding: 6px 0;
}
.demo-timeline-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.demo-track-wrap:focus-within {
  outline: 2px solid var(--vs-primary);
  outline-offset: 4px;
  border-radius: 8px;
}
.playback-bar__controls svg {
  fill: none;
}
@media (max-width: 767px) {
  .demo-playback {
    grid-template-columns: 1fr auto;
    gap: 12px;
  }
  .playback-bar__date {
    display: none;
  }
  .playback-bar__timeline {
    grid-column: 1/-1;
  }
  .playback-bar__controls {
    grid-column: 1/-1;
    justify-content: center;
  }
}
</style>
